import { useNavigate } from "react-router-dom";
import ArrowBackRounded from "@mui/icons-material/ArrowBackRounded";
import { Box, Button } from "@mui/material";

export default function BackButton() {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        width: "100%",
        mb: { xs: 1.5, md: 2 },
        px: { xs: 1, sm: 2, md: 0 },
        pt: { xs: 0, md: 0.5 },
      }}
    >
      <Button
        type="button"
        variant="outlined"
        disableElevation
        onClick={() => navigate(-1)}
        startIcon={
          <ArrowBackRounded sx={{ fontSize: 20, color: "common.green" }} />
        }
        sx={{
          borderRadius: 999,
          textTransform: "none",
          fontWeight: 600,
          fontSize: 15,
          letterSpacing: "0.02em",
          px: 2.25,
          py: 1,
          minHeight: 42,
          color: "text.primary",
          borderWidth: 1.5,
          borderColor: "rgba(0, 127, 24, 0.28)",
          bgcolor: "background.paper",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)",
          transition: "background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease",
          "&:hover": {
            borderWidth: 1.5,
            bgcolor: "rgba(0, 127, 24, 0.07)",
            borderColor: "common.green",
            boxShadow: "0 4px 14px rgba(0, 127, 24, 0.14)",
          },
        }}
      >
        Back
      </Button>
    </Box>
  );
}
